import TWIACommonUtil from './TWIACommonUtil';

// 2024-10-04 - Policy Documents - Policy Documents
export default class TWIADocumentUtil {

    static getPolicyDocumentTypeFilterName(productCode) {
        if (TWIACommonUtil.isHomeOwners(productCode)) {
            return 'TwiaPortalResPolicyUploadDocTypesFilter_Ext';
        } else if (TWIACommonUtil.isCommercialProperty(productCode)) {
            return 'TwiaPortalComPolicyUploadDocTypesFilter_Ext';
        }

        return 'TwiaUploadDocTypesFilter_Ext';
    }

    static getJobDocumentTypeFilterName(productCode) {
        if (TWIACommonUtil.isHomeOwners(productCode)) {
            return 'TwiaPortalResJobUploadDocTypesFilter_Ext';
        } else if (TWIACommonUtil.isCommercialProperty(productCode)) {
            return 'TwiaPortalComJobUploadDocTypesFilter_Ext';
        }
        
        return 'TwiaUploadDocTypesFilter_Ext';
    }

}
